/* global axios */
export default {
  get(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/storm_reports`);
  },
};
